import React from 'react';
import { Icon } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import { StyledListItem, StyledMoreDropDown } from './NavigationStyles';
import { messages } from '../../i18n/messages';

interface PriorityDropDownItemProps {
  handlePriorityDropDownClick: () => void;
  activePriortyDropDown: boolean;
  isMobile?: boolean;
  priorityNavLoaded?: boolean;
  priorityItemslength?: number;
}

const PriorityDropDownItem = ({
  handlePriorityDropDownClick,
  activePriortyDropDown,
  isMobile,
  priorityNavLoaded,
  priorityItemslength,
}: PriorityDropDownItemProps) => {
  const popOverAriaLabels = {
    show_additional_navigation_items: useI18n(messages.show_additional_navigation_items),
    hide_additional_navigation_items: useI18n(messages.hide_additional_navigation_items),
  };
  return (
    <StyledListItem
      id="moreMenuList"
      role="none"
      $isMobile={isMobile}
      $priorityNavLoaded={priorityNavLoaded}
      $priorityItemslength={priorityItemslength}
      $hidePriorityDropDown={priorityItemslength ? priorityItemslength > 0 : false}
    >
      <StyledMoreDropDown
        onClick={handlePriorityDropDownClick}
        $activePriortyDropDown={activePriortyDropDown}
        $priorityNavLoaded={priorityNavLoaded}
        aria-label={
          activePriortyDropDown
            ? popOverAriaLabels.hide_additional_navigation_items
            : popOverAriaLabels.show_additional_navigation_items
        }
      >
        <Icon name="arrow-up" size="l" />
      </StyledMoreDropDown>
    </StyledListItem>
  );
};

export default PriorityDropDownItem;
